/**
 * Fetch "sagrado": capturado al momento de importar este módulo,
 * ANTES de que Google MediaPipe o Amplify patcheen window.fetch.
 *
 * Google MediaPipe inyecta un script de telemetría (odml.pa.googleapis.com)
 * que reemplaza window.fetch y, cuando el endpoint devuelve 403, el wrapper
 * explota con "Cannot read properties of undefined (reading 'M_ID')",
 * rompiendo TODAS las llamadas a la API.
 *
 * Solución: capturar la referencia nativa acá y usarla en client.js.
 *
 * IMPORTANTE: este módulo debe importarse ANTES que cualquier módulo que
 * cargue MediaPipe (a través de App.jsx o algún componente).
 */

const nativeFetch = (typeof window !== "undefined" && window.fetch)
  ? window.fetch.bind(window)
  : null

export default nativeFetch
